import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxBoxModule, DxButtonModule } from 'devextreme-angular';
import { HttpService } from '../../../http.service';
import { ActionType, MerchantStatus } from '../../home/models';
import { FormPopupModule } from '../../../components/library/form-popup/form-popup.component';
import { RichFormModule } from '../../../components/library/rich-form/rich-form.component';
import { FormGroup } from '@angular/forms';
import notify from 'devextreme/ui/notify';

@Component({
  standalone: true,
  imports: [
    DxBoxModule,
    DxButtonModule,
    CommonModule,
    FormPopupModule,
    RichFormModule,
  ],
  selector: 'app-decline',
  templateUrl: './decline.component.html',
  styleUrl: './decline.component.scss'
})
export class DeclineComponent {

  @Input() isDeclinedMerchantPopupOpened: boolean = false;
  @Input() merchantId: number = 0;
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();

  formUiWidgets!: Record<string, any>[];
  data: Record<string, any> = {
    additionalInfo: '',
    reasonType: 0
  }
  isLoading = false;
  isContentScrolled = false;
  dataForm!: FormGroup;
  reasonTypes: Array<string> = ["Merchant not compliant", "Reason 2"];

  constructor(private httpService: HttpService) {
  }

  ngOnInit(): void {
    this.formUiWidgets = this.getFormControls();
  }

  getFormControls() {
    return [
      {
        label: 'Reason type',
        dataField: 'reasonType',
        editorType: 'dxSelectBox',
        colSpan: 1,
        width: '150px',
        editorOptions: {
          items: this.reasonTypes,
        },
        FormType: 'DeclineStatusForm'
      },
      {
        label: 'Additional notes',
        dataField: 'additionalInfo',
        colSpan: 1,
        width: '150px',
        height: '80px',
        FormType: 'DeclineStatusForm'
      },
    ]
  }

  scroll({ reachedTop = false }) {
    this.isContentScrolled = !reachedTop;
  }

  dataChanged(object) {
    //set populated form field 
    if ('event' in object) {
      this.dataForm.patchValue({
        [object.event.dataField]: object.event.value
      });
    }

    this.notifyContainerDataChanged.emit(object);
  }


  onDeclinedClick(e: any) {
    this.isDeclinedMerchantPopupOpened = true;
  }

  onConfirmDeclinedClick(e: any) {
    let model = new MerchantStatus(this.merchantId, ActionType.Declined, this.data['additionalInfo'], this.data['reasonType']);
    this.httpService.changeMerchantStatus(model).subscribe(res => {
      notify({
        message: 'Merchant is declined!',
        position: {
          my: 'center top',
          at: 'center top',
        },
      }, 'success', 3000);
    });
  }
}
